import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Flatpickr-powered date input (TailAdmin look comes from the .flatpickr-*
// overrides in app/assets/tailwind/application.css). The input keeps its
// ISO "Y-m-d" value for the server while the visible altInput shows "d.m.Y".
// On pick/clear we re-dispatch `input` from the original input so a wrapping
// admin-auto-submit form reacts the same way as to manual typing.
export default class extends Controller {
  connect() {
    this.picker = flatpickr(this.element, {
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d.m.Y",
      onChange: () => {
        this.element.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  }

  disconnect() {
    this.picker?.destroy()
  }
}
